import { MainTab } from './tabs';

export default MainTab;
